import styled from 'styled-components'

import Text from 'components/Atoms/Text'
import { useTranslation } from 'i18n-web/i18next'

const Title = styled(Text)`
  font-size: ${props => props.theme.font.size.mobile.h3};
  color: ${props => props.theme.palette.grayDark};
  margin-bottom: 10px;
  text-transform: uppercase;

  @media (min-width: ${props => props.theme.flexboxgrid.breakpoints.sm}rem) {
    margin-bottom: 15px;
    font-size: ${props => props.theme.font.size.desktop.h3};
  }
`

const Description = styled(Text)`
  margin-bottom: 25px;
  font-size: ${props => props.theme.font.size.mobile.small};
  line-height: 170%;

  @media (min-width: ${props => props.theme.flexboxgrid.breakpoints.md}rem) {
    margin-bottom: 0;
    max-width: 400px;
    font-size: ${props => props.theme.font.size.desktop.regular};
  }
`

const Copy = () => {
  const { t } = useTranslation()

  return (
    <>
      <Title as="h1">{t('howItWorks.hero.title')}</Title>
      <Description className="grayDark">
        {t('howItWorks.hero.description')}
      </Description>
    </>
  )
}

export default Copy
